import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import routes from 'store/configs/Routes';
import TopBarComponent from './TopBarComponent';

import './HeaderComponent.scss';
import { useWindowSize } from 'util/window';
import { Link } from 'react-router-dom';

const HeaderComponent: React.FunctionComponent = () => {
  const { isMobile } = useWindowSize();
  const [mobileOpen, setMobileOpen] = useState(isMobile);

  const closeMobileNav = () => setMobileOpen(false);
  const toggleMobileNav = () => setMobileOpen(!mobileOpen);

  return (
    <nav id="headerComponent" className="site-header navbar-expand-md navbar-light container-fluid">
      <div id="topBarWrapper" className="row">
        <div className="col-12">
          <div className="container d-none d-md-block py-1">
            <TopBarComponent hideLogin={false} />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <img className="pt-2 d-block d-md-none float-left" height={40} src="/images/logo.svg" alt="Semi" />
          <button
            className="navbar-toggler float-right m-1"
            type="button"
            aria-label="Toggle navigation"
            onClick={toggleMobileNav}
          >
            <span className="navbar-toggler-icon" />
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="container">
            <div id="headerNav" className={'collapse navbar-collapse ' + (mobileOpen ? 'show' : '')}>
              <Link className="navbar-brand d-none d-md-block" to={routes.root}>
                <img src="/images/logo.svg" alt="Semi" />
              </Link>

              <ul className="navbar-nav ml-auto">
                <li>
                  <NavLink
                    to={routes.home}
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    onClick={closeMobileNav}
                  >
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={routes.account.root}
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    onClick={closeMobileNav}
                  >
                    Account
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={routes.standardsBallot.root}
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    onClick={closeMobileNav}
                  >
                    Standards Ballots
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={routes.meetings}
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    onClick={closeMobileNav}
                  >
                    Standards Meetings
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={routes.productDownload}
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    onClick={closeMobileNav}
                  >
                    Product Download
                  </NavLink>
                </li>
              </ul>

              <TopBarComponent extraClasses="d-block d-md-none" />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderComponent;
